<!-- 左侧菜单 -->
<template>
	<div class="leftMenu">
		<ul>
			<li v-for="(item, index) in leftMenu" :key="item .id" 
				:class="{ active: iscurLeft == index }"  
				@click="setCur(index)">{{ item.title }}
			</li>
		</ul>
	</div>
</template>
<script>
	export default {
	    components: {},
	    props:{
			leftMenu:{
				type:Array
			},
		},
	  data() {
	    return {
			iscurLeft:0
		}
	  },
	  watch: {
		'$route.path': {
			handler(newVal, oldVal) {
				//判断newVal有没有值监听路由变化
				this.$nextTick(()=>{
					if (newVal == '/solution') {
						// console.log('当前路由',newVal)
						// console.log('上一个路由',oldVal)
						this.iscurLeft = 0
					}
				})
			},
			deep: true
		},
	  },
	  mounted() {
			this.init()
		},
		methods: {
			setCur(index) {//本地会话存储菜单
				this.iscurLeft = index
				this.$emit('childClick',index)
			},
			init(){
				var changeLeftListId = sessionStorage.getItem('changeLeftListId')
					if(changeLeftListId !=undefined){
						this.iscurLeft = changeLeftListId
					}
					this.setCur(this.iscurLeft)
			}
		}
	}
</script>
<style scoped lang="scss">
  .leftMenu{
	width: 260px;
	
	 ul{
		border:1px solid #ddd;
		li{
			background-color:#fff;
			line-height: 32px;
			padding:10px 10px 10px 20px;
			border-left:3px solid #fff;
			cursor: pointer;
		}
		li.active, li:hover{
			background-color: #f9f9f9;
			color:#409eff;
			border-left:3px solid #409eff;
		}
		p.title{
			line-height: 32px;
			padding:10px 10px 10px 20px;
			border-left:3px solid #fff;
			font-weight:bold;
			border-bottom: 1px solid #ddd;
		}
	 }
  }
</style>